// extracted by mini-css-extract-plugin
export var editButton = "_m0-0";